import Pusher from 'pusher-js'
import { useEffect, useState } from 'react'

const pusherChannelName = 'dash'

export const useRecoveryCertificateEvent = () => {
  const [recoveryCertificateClaimed, setRecoveryCertificateClaimed] = useState()
  const [recoveryCertificateHandled, setRecoveryCertificateHandled] = useState()

  useEffect(() => {
    const pusher = new Pusher(process.env.GATSBY_PUSHER_APP_KEY, {
      cluster: process.env.GATSBY_PUSHER_CLUSTER,
    })

    const channel = pusher.subscribe(pusherChannelName)

    channel.bind('recoveryCertificateClaimed', (data) => {
      console.log('pusher', 'recoveryCertificateClaimed', data)
      setRecoveryCertificateClaimed(data)
    })

    channel.bind('recoveryCertificateHandled', (data) => {
      console.log('pusher', 'recoveryCertificateHandled', data)
      setRecoveryCertificateHandled(data)
    })

    return () => pusher.unsubscribe(pusherChannelName)
  }, [])

  return { recoveryCertificateClaimed, recoveryCertificateHandled }
}

export default useRecoveryCertificateEvent

// {
//   console.log(
//     'pusher',
//     'recoveryCertificateClaimed',
//     data,
//     recoveryCertificates?.length,
//     recoveryCertificates
//   )
//
//   if (data?.orderId && recoveryCertificates) {
//     console.log('update this')
//     setRecoveryCertificates(
//       recoveryCertificates.map((recoveryCertificate) => {
//         if (recoveryCertificate.orderId === data?.orderId) {
//           recoveryCertificate = {
//             ...recoveryCertificate,
//             claimedBy: data?.claimedBy,
//             claimedAt: data?.claimedAt,
//           }
//         }
//         return recoveryCertificate
//       })
//     )
//   }
// }
